import React from 'react';
import { Divider, Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import TemperaturesSection from './TemperaturesSection';
import ProductionSheets from './ProductionSheets';
import { useTranslation } from 'react-i18next';
import { TCategoryProductSheet } from '../../types/product';

export interface IFormTemperatures {
  name: string;
  isRequired: boolean;
  setIsRequired: any;
  temperatures: any;
  setTemperatures: any;
  errorValidations?: any;
  setErrors?: any;
  type: any;
}

interface HoldingProfileFormProps {
  region?: string;
  country?: string;
  formProfiles: any;
  availability?: any;
  productSheet: TCategoryProductSheet;
  testMarketFlag?: boolean;
  isEdit?: boolean;
  setProductSheet: (productSheet: TCategoryProductSheet) => void;
  setIsTestMarketFlag: (isTestMarket: boolean) => void;
}

export function HoldingProfileForm({
  region,
  country,
  formProfiles,
  isEdit,
  availability,
  productSheet,
  testMarketFlag,
  setProductSheet,
  setIsTestMarketFlag,
}: HoldingProfileFormProps) {
  const { t } = useTranslation();
  const notForTestMarket =
    availability.filter(a => a.region == region && !country).length > 0 ||
    availability.filter(a => a.region == region && a.country == country)
      .length > 0;
  return (
    <>
      <Grid item xs={12}>
        <ProductionSheets
          notForTestMarket={notForTestMarket}
          region={region}
          isEdit={isEdit}
          productSheet={productSheet}
          setProductSheet={setProductSheet}
          testMarketFlag={testMarketFlag}
          setIsTestMarketFlag={setIsTestMarketFlag}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography style={{ fontSize: 14, fontWeight: 600 }} align="center">
          {t('holdingProfile.minMaxTemperatures')}
        </Typography>
      </Grid>
      {formProfiles?.map((profile: IFormTemperatures, index) => (
        <React.Fragment key={index}>
          <Grid item xs={12}>
            <TemperaturesSection {...profile} />
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 15, marginTop: 10 }}>
            <Divider />
          </Grid>
        </React.Fragment>
      ))}
    </>
  );
}
